export default __webpack_public_path__ + "static/media/an.db73c245.svg";